import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/arrow-left.png'
import _imports_1 from './images/arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-bce0ca2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "swiper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "box-carousel-inner" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["srcset", "media"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "box-indicator" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

import { onMounted, ref } from 'vue';
  import { Carousel } from 'bootstrap';
  import waitDialogVue from '../wait-dialog.vue';

  type TSlide = {
    image: string;
    imageMobile: string;
    indicator: string;
    indicatorActive: string;
    link: string;
  }

  interface IProps {
    slides: TSlide[]
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    slides: { default: () => [] }
  },
  setup(__props: any) {

  const dialog = ref(false);

  ;

  

  const root = ref();
  const current = ref(0);
  let carousel: Carousel;

  const on = {
    'slide.bs.carousel'(e: Carousel.Event) {
      current.value = e.to;
    }
  };

  const initCarousel = () => {
    if (carousel) {
      carousel.dispose();
    }
    carousel = new Carousel(root.value, {
      interval: 6000
    });
    carousel.cycle();
  };

  const handleSlideTo = (to: number) => {
    carousel.to(to);
  };

  const handleSlideNext = () => {
    carousel.next();
  };

  const handleSlidePrev = () => {
    carousel.prev();
  };

  onMounted(initCarousel);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "btn-control left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSlidePrev()))
      }, _hoisted_3),
      _createElementVNode("div", _mergeProps({
        ref_key: "root",
        ref: root,
        class: "carousel slide"
      }, _toHandlers(on)), [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slides, (slide, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["carousel-item", { active: index === 0 }])
            }, [
              _createElementVNode("a", {
                class: "link-btn",
                href: slide.link,
                target: "_blank"
              }, null, 8, _hoisted_5),
              _createElementVNode("picture", null, [
                _createElementVNode("source", {
                  srcset: slide.imageMobile,
                  media: `(max-width: ${576}px)`
                }, null, 8, _hoisted_6),
                _createElementVNode("img", {
                  src: slide.image
                }, null, 8, _hoisted_7)
              ])
            ], 2))
          }), 128))
        ])
      ], 16),
      _createElementVNode("div", {
        class: "btn-control right",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSlideNext()))
      }, _hoisted_9)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slides, (slide, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["indicator", { active: index === current.value }]),
          onClick: ($event: any) => (handleSlideTo(index))
        }, [
          _withDirectives(_createElementVNode("img", {
            src: slide.indicatorActive
          }, null, 8, _hoisted_12), [
            [_vShow, index === current.value]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: slide.indicator
          }, null, 8, _hoisted_13), [
            [_vShow, index !== current.value]
          ])
        ], 10, _hoisted_11))
      }), 128))
    ]),
    _createVNode(waitDialogVue, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})